import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Luxurious%20dark%20entertainment%20platform%20background%20with%20warm%20golden%20particles%20floating%2C%20abstract%20geometric%20patterns%2C%20deep%20charcoal%20and%20rich%20crimson%20gradient%2C%20elegant%20modern%20atmosphere%2C%20cinematic%20lighting%2C%20no%20text%2C%20clean%20dark%20aesthetic&width=1800&height=1000&seq=hero-bg-main&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/40 to-foreground-950/70"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 text-center">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent-500/20 border border-accent-500/30 mb-8 animate-fade-in-up">
            <i className="ri-sparkling-2-line text-accent-400 text-sm"></i>
            <span className="text-sm text-accent-300 font-medium">2026年度最佳游戏平台</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 leading-tight mb-6 animate-fade-in-up-delay-1">
            精彩娱乐，从
            <span className="text-primary-400">九游</span>
            开始
          </h1>

          <p className="text-base md:text-lg text-background-300 max-w-2xl mx-auto mb-10 leading-relaxed animate-fade-in-up-delay-2">
            九游娱乐汇聚海量精品游戏与顶级娱乐内容，为玩家提供安全、流畅、公平的游戏环境。
            7×24小时客服守护，丰厚会员福利，立即加入开启精彩之旅。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-up-delay-3">
            <Link
              to="/categories"
              className="px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-all duration-200 text-base whitespace-nowrap w-full sm:w-auto"
            >
              进入游戏大厅
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/about"
              className="px-8 py-3.5 bg-background-50/10 text-background-50 font-medium rounded-lg hover:bg-background-50/20 border border-background-50/20 transition-all duration-200 text-base whitespace-nowrap w-full sm:w-auto"
            >
              了解更多
            </Link>
          </div>

          <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
            {[
              { value: '5000万+', label: '注册用户' },
              { value: '2000+', label: '精品游戏' },
              { value: '99.9%', label: '好评率' },
              { value: '7×24h', label: '客服在线' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-bold font-heading text-accent-400">
                  {stat.value}
                </div>
                <div className="text-sm text-background-400 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}